import React from 'react'
import { INewsItem } from '../../../app/reducers/news/news.slice'
import styles from './News.module.scss'

const maxLength = 142

function capitalizeFirstLetter(string: String) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

interface Props extends React.HTMLProps<HTMLDivElement> {
	newsItem: INewsItem
}

const NewsItem: React.FC<Props> = ({ newsItem, onClick }) => {
	const text = newsItem.content
	const croppedText =
		text.length > maxLength ? `${text.substring(0, maxLength)}...` : text

	const d = new Date(newsItem.published)

	const day = d.getDate()
	const month = d.getMonth() + 1
	const year = d.getFullYear()

	return (
		<div className={styles.newsItem} onClick={onClick}>
			<div className={styles.date}>
				<span className={styles.dateDay}>{day < 10 ? '0' + day : day}.</span>
				<span className={styles.dateMonth}>
					{month < 10 ? '0' + month : month}.
				</span>
				<span className={styles.dateYear}>{year}</span>
			</div>
			<h3 className={styles.newsTitle}>{newsItem.title}</h3>
			<div
				className={['p3 gray', styles.newsText].join(' ')}
				dangerouslySetInnerHTML={{ __html: croppedText }}
			></div>
		</div>
	)
}

export default NewsItem
